import React, { useState, useEffect } from 'react';
import { colors, radius, fonts } from '../theme';
import { community } from '../api';

export function NotificationsPage() {
  const [notifs, setNotifs] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    community.notifications().then(r => setNotifs(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const markRead = async (id: number) => {
    await community.markRead(id);
    setNotifs(prev => prev.map(n => n.id === id ? { ...n, is_read: true } : n));
  };

  const markAllRead = async () => {
    await community.markAllRead();
    setNotifs(prev => prev.map(n => ({ ...n, is_read: true })));
  };

  const typeEmoji: Record<string, string> = {
    event: '🎉', promo: '🏷️', birthday: '🎂', system: '🔔', loyalty: '⭐', social: '💬',
  };

  const unread = notifs.filter(n => !n.is_read).length;

  if (loading) return <div style={{ color: colors.text, textAlign: 'center', padding: 40 }}>Chargement...</div>;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <div>
          <h2 style={{ color: colors.gold, fontSize: 24, margin: 0 }}>Notifications</h2>
          {unread > 0 && <span style={{ color: colors.textMuted, fontSize: 13 }}>{unread} non lue(s)</span>}
        </div>
        {unread > 0 && (
          <button onClick={markAllRead} style={{ background: 'none', border: `1px solid ${colors.gold}`, color: colors.gold, borderRadius: radius.sm, padding: '6px 14px', cursor: 'pointer', fontSize: 13, fontFamily: fonts.body }}>
            Tout marquer comme lu
          </button>
        )}
      </div>

      {notifs.length === 0 ? (
        <p style={{ color: colors.textMuted, textAlign: 'center', padding: 40 }}>Aucune notification</p>
      ) : (
        notifs.map(n => (
          <div key={n.id} onClick={() => !n.is_read && markRead(n.id)} style={{
            background: n.is_read ? colors.card : `${colors.gold}10`,
            borderRadius: radius.md, padding: 16,
            border: `1px solid ${n.is_read ? colors.border : `${colors.gold}40`}`,
            marginBottom: 8, cursor: n.is_read ? 'default' : 'pointer',
          }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
              <span style={{ fontSize: 24 }}>{typeEmoji[n.notification_type] || '🔔'}</span>
              <div style={{ flex: 1 }}>
                <div style={{ color: colors.text, fontWeight: n.is_read ? 'normal' : 'bold', fontSize: 14 }}>{n.title}</div>
                <div style={{ color: colors.textMuted, fontSize: 13, marginTop: 2 }}>{n.message}</div>
                <div style={{ color: colors.textMuted, fontSize: 11, marginTop: 4 }}>{new Date(n.created_at).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}</div>
              </div>
              {!n.is_read && <div style={{ width: 8, height: 8, borderRadius: '50%', background: colors.gold, marginTop: 6 }} />}
            </div>
          </div>
        ))
      )}
    </div>
  );
}